import styled from 'styled-components';

export const ButtonStyled = styled.button`

    outline: none;
    border: none;
    background-color: ${function(props) {
        if(props.success) {
            return '#51AB76'
        } else if(props.danger) {
            return '#D74444'
        } else {
            return 'grey'
        }
    }};
    color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return 'black';
                    break;
                case 'light':
                    return 'white';
                    break;
                default:
                    return 'white';
            }
        }};
    font-size: 20px;
    font-weight: 700;
    padding: 10px;
    border-radius: 15px;
    box-shadow: 0 2px 3px hsl(0deg 0% 0% / 0.3);
    transition: .3s ease all;

    &:hover {
        opacity: .4;
    }

    &:focus {
        transition: 0s;
        outline: 3px solid #A7A7A7;
    }

    @media screen and (max-width: 576px){
        font-size: 18px;
    }
`;